import React, { useState, Fragment } from "react";
import ExternalLink from "components/ExternalLink";
import { VIEW_ON_STRIPE, REACT_KEY } from "utils/constants/ui";
import { useCtxReferences } from "utils/selectors";
import { getAccountConnectStatusProps } from "utils/merchantAccount";
import SERVICES from "utils/constants/services";
import StripeExternalLink from "components/StripeExternalLink";
import merge from "lodash/merge";
import HoverIconButton from "components/HoverIconButton";
import classnames from "classnames";
import cloneDeep from "lodash/cloneDeep";

const DEFAULT_CLASSES = {
  container: "ba b--black-10 br2 w-100",
  header: {
    container: "pa3 w-100 flex flex-row justify-between items-center",
    title: "fw6 f4 w-100",
    action: "flex"
  },
  content: "list pa3 ma0 w-100"
};

const SectionBezel = ({
  error,
  header,
  action,
  children,
  customClasses,
  footer,
  expandable,
  // Uncontrolled initial state
  open,
  // Controlled params
  isOpen,
  setOpen
}) => {
  const classes = merge(cloneDeep(DEFAULT_CLASSES), customClasses);
  const { merchantAccount } = useCtxReferences();
  const [expanded, setExpanded] = useState(open || !expandable);
  const iconType = expanded || isOpen ? "up" : "down";

  const account =
    merchantAccount && getAccountConnectStatusProps(merchantAccount);

  let ctxAction;
  if (action) {
    if (action[REACT_KEY]) {
      ctxAction = action;
    } else if (action.service === SERVICES.STRIPE) {
      ctxAction = (
        <StripeExternalLink
          account={account}
          tooltip={VIEW_ON_STRIPE}
          copy={`Manage on Stripe`}
          href={action.url}
        />
      );
    } else {
      ctxAction = (
        <ExternalLink
          href={action.url}
          tooltip={VIEW_ON_STRIPE}
          copy={action.copy}
          customClasses={{ copy: "f5 pr1" }}
        />
      );
    }
  }

  const toggleExpanded = () => {
    // Controlled
    if (setOpen) {
      setOpen(!isOpen);
    } else {
      // Uncontrolled
      setExpanded(!expanded);
    }
  };
  const controlled = Boolean(setOpen && isOpen);

  return (
    <div className={classes.container}>
      <div
        className={classnames(classes.header.container, {
          "bb b--black-10": expanded
        })}
      >
        <div
          onClick={expandable ? toggleExpanded : () => {}}
          className={classnames(classes.header.title, {
            "pointer": expandable,
            "color-error": error
          })}
        >
          {header}
        </div>
        <div className="w-auto flex flex-row items-center flex-shrink-0">
          {ctxAction && (
            <div
              className={classnames(classes.header.action, {
                pr2: expandable
              })}
            >
              {ctxAction}
            </div>
          )}
          {expandable ? (
            <div className="pl2 bl hairline-1">
              <HoverIconButton type={iconType} onClick={toggleExpanded} />
            </div>
          ) : null}
        </div>
      </div>
      {(controlled || expanded) && (
        <Fragment>
          <div className={classes.content}>{children}</div>
          {footer}
        </Fragment>
      )}
    </div>
  );
};

export default SectionBezel;
